/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row2_LinearInputs */

const en_mk_cmp_row2_linear = /** @type {(inputs: Mk_Cmp_Row2_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product & technical teams`)
};

const id_mk_cmp_row2_linear = /** @type {(inputs: Mk_Cmp_Row2_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim produk & teknis`)
};

/**
* | output |
* | --- |
* | "Product & technical teams" |
*
* @param {Mk_Cmp_Row2_LinearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row2_linear = /** @type {((inputs?: Mk_Cmp_Row2_LinearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row2_LinearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row2_linear(inputs)
	return en_mk_cmp_row2_linear(inputs)
});